import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('people/trips'),
}

export default actions

export function load(params) {
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}

export function reset() {
  return {
    type: actions.RESET,
  }
}
